// extracted by mini-css-extract-plugin
export default {"tableRegister":"component_tableRegister__YrMkd"};